import getVenuesList from '../../../api/graphql/queries/getVenuesList';
import getPostsByCategory from '../../../api/graphql/queries/getPostsByCategory';
import getArtistSetsList from '../../../api/graphql/queries/getArtistSetsList';
import postDeleteArtistSet from '../../../api/graphql/mutations/postDeleteArtistSet';
import postAddArtistSet from '../../../api/graphql/mutations/postAddArtistSet';
import postEditArtistSet from '../../../api/graphql/mutations/postEditArtistSet';
import slugify from '../../../utils/slugify';

const itemName = 'artistSetSlugName';

export const reducerInitialState = {
  filterText: '',
  isCreateModalOn: false,
  isDisplayModalOn: false,
  isModifyModalOn: false,
  isDeleteModalOn: false,
  formOutput: {},
  currItemData: [],
  isDeleteInfoScreenOpen: false,
  filteredItems: [],
  isLoading: true,
  canItemBeDeleted: false,
  venuesSlugNames: [],
  artistSlugNamesToArtistName: [],
  page: 0,
  total: 0,
  rowsPerPage: 50,
  sorting: ['createdAt', -1],
};

// TODO: REMOVE EVERYTHING, THIS IS CODE IS TERRIBLE =)
export const reducer = (state, action) => {
  switch (action.type) {
    case 'manageFilterText':
      return { ...state, filterText: action.filterText };
    case 'makeBooleanTrue':
      return { ...state, [action.booleanName]: true };
    case 'makeBooleanFalse':
      return { ...state, [action.booleanName]: false };
    case 'makeBooleanOpposite':
      return { ...state, [action.booleanName]: !state[action.booleanName] };
    case 'manageFormOutput':
      return { ...state, formOutput: action.formOutput };
    case 'manageCurrItemData':
      return { ...state, currItemData: action.currItemData };
    case 'manageFilteredItems':
      return { ...state, filteredItems: action.filteredItems };
    case 'manageVenuesSlugNames':
      return { ...state, venuesSlugNames: action.venuesSlugNames };
    case 'manageArtistSlugNamesToArtistName':
      return { ...state, artistSlugNamesToArtistName: action.artistSlugNamesToArtistName };
    case 'manageArtistSlugNames':
      return { ...state, artistSlugNames: action.artistSlugNames };
    case 'managePage':
      return { ...state, page: action.page, total: action.total };
    case 'manageRowsPerPage':
      return { ...state, rowsPerPage: action.rowsPerPage };
    case 'manageSorting':
      return { ...state, sorting: action.sorting };
    default:
      return state;
  }
};

export const getVenues = (history, dispatch, _isMounted) => {
  getVenuesList().then((venuesData) => {
    if (venuesData) {
      if (venuesData.isAuth) {
        const venuesSlugNames = venuesData.venues.map(i => i.venueSlugName);
        if (_isMounted) {
          dispatch({ type: 'manageVenuesSlugNames', venuesSlugNames });
        }
      } else {
        console.log('getVenuesList - User authentication failed!');
        history.push('/login');
      }
    } else {
      console.log('venuesData = null');
    }
  });
};

export const getArtistPosts = (history, dispatch, _isMounted) => {
  getPostsByCategory('artist').then((artistInfo) => {
    if (artistInfo) {
      if (artistInfo.isAuth) {
        const array = [];

        artistInfo.posts.forEach(i => array.push({ [i.slugName]: i.postDescription && i.postDescription.hasOwnProperty('title') && i.postDescription.title !== null ? i.postDescription.title.en : '' }));
        const artistSlugNames = artistInfo.posts.map(artistPost => artistPost.slugName) || [];
        if (_isMounted) {
          dispatch(
            { type: 'manageArtistSlugNamesToArtistName', artistSlugNamesToArtistName: array },
          );
          dispatch(
            { type: 'manageArtistSlugNames', artistSlugNames },
          );
        }
      } else {
        console.log('artistInfo - User authentication failed!');
        history.push('/login');
      }
    } else {
      console.log('venuesData = null');
    }
  });
};

export const getArtistSetsBySearchString = async (val = '') => {
  const artistSetsResult = await getArtistSetsList(val.toLowerCase());
  return artistSetsResult;
};

/*
One page of artist sets. The list used to render nothing until three characters
were typed, because the query returned the whole collection and there was
nothing else holding it back; it pages now, so a search is a filter rather than
a precondition.
*/
export const loadPage = async (search, page, dispatch, rowsPerPage = 50, sorting = ['createdAt', -1]) => {
  dispatch({ type: 'makeBooleanTrue', booleanName: 'isLoading' });
  const result = await getArtistSetsList((search || '').toLowerCase(), {
    limit: rowsPerPage,
    offset: page * rowsPerPage,
    sortField: sorting[0],
    sortOrder: sorting[1],
  });
  dispatch({ type: 'manageFilteredItems', filteredItems: (result && result.artistSets) || [] });
  dispatch({ type: 'managePage', page, total: (result && result.total) || 0 });
  dispatch({ type: 'makeBooleanFalse', booleanName: 'isLoading' });
};

// A new search starts again at the first page: staying on page 7 of the
// previous result set would land the editor on an empty screen.
export const updateSearch = async (val, dispatch) => {
  await loadPage(val, 0, dispatch);
};

export const updateSearchTerm = async (val, dispatch) => {
  dispatch({ type: 'makeBooleanTrue', booleanName: 'isLoading' });
  dispatch({ type: 'manageFilterText', filterText: val });
};


const toggleCreateModal = (dispatch) => {
  dispatch({ type: 'makeBooleanOpposite', booleanName: 'isCreateModalOn' });
};

const toggleDisplayModal = (item, dispatch, filteredItems) => {
  const currItemData = filteredItems.filter(el => el[itemName] === item);
  dispatch({ type: 'makeBooleanOpposite', booleanName: 'isDisplayModalOn' });
  dispatch({ type: 'manageCurrItemData', currItemData });
};

const toggleModifyModal = (item, dispatch, filteredItems) => {
  const currItemData = filteredItems.filter(el => el[itemName] === item);
  dispatch({ type: 'makeBooleanOpposite', booleanName: 'isModifyModalOn' });
  dispatch({ type: 'manageCurrItemData', currItemData });
};

const toggleDeleteModal = (item, dispatch, filteredItems) => {
  const currItemData = filteredItems && filteredItems.length ? filteredItems.filter(el => el[itemName] === item) : [];
  dispatch({ type: 'makeBooleanOpposite', booleanName: 'isDeleteModalOn' });
  dispatch({ type: 'manageCurrItemData', currItemData });
};

export const toggleDeleteInfoScreen = (dispatch) => {
  dispatch({ type: 'makeBooleanOpposite', booleanName: 'isDeleteInfoScreenOpen' });
};

export const handleClick = (action, item = '', dispatch, filteredItems = []) => {
  console.log(`And the action is: ${action}, for item ${item}`);

  switch (action) {
    case 'create':
      toggleCreateModal(dispatch);
      break;
    case 'display':
      toggleDisplayModal(item, dispatch, filteredItems);
      break;
    case 'modify':
      toggleModifyModal(item, dispatch, filteredItems);
      break;
    case 'delete':
      toggleDeleteModal(item, dispatch, filteredItems);
      break;
    case 'closeDeleteItem':
      toggleDeleteInfoScreen(dispatch);
      break;
    default:
      console.log('wrong action!');
      break;
  }
};

export const handleDelete = (itemId, itemSlug, history, filterText, dispatch) => {
  console.log(`the item ${itemSlug} will be deleted`);

  const formData = {
    id: itemId,
    artistSetSlugName: slugify(itemSlug.toLowerCase()),
  };

  postDeleteArtistSet({ ...formData }).then((postDeleteArtistSetResultData) => {
    if (postDeleteArtistSetResultData) {
      if (postDeleteArtistSetResultData.isAuth) {
        if (postDeleteArtistSetResultData.isDeleted) {
          console.log(`postDeleteArtistSet - Successfully deleted artist set with artistSetSlugName ${postDeleteArtistSetResultData.artistSetSlugName}!`);
          toggleDeleteInfoScreen(dispatch);
          updateSearch(filterText || '', dispatch);
          dispatch({ type: 'makeBooleanTrue', booleanName: 'canItemBeDeleted' });
          dispatch({ type: 'filterText', filterText });
        } else {
          if (postDeleteArtistSetResultData.isUsed.eventSlugNames.length === 0) {
            console.log('postDeleteArtistSet - Failed to delete artist set! Artist set does not exist.');
          } else if (postDeleteArtistSetResultData.isUsed.eventSlugNames.length > 0) {
            console.log(`postDeleteArtistSet - Failed to delete artist set! Artist set is used in eventSlugNames: ${postDeleteArtistSetResultData.isUsed.eventSlugNames}`);
            toggleDeleteInfoScreen(dispatch);
            dispatch({ type: 'makeBooleanFalse', booleanName: 'canItemBeDeleted' });
          }
        }
      } else {
        console.log('postDeleteArtistSet - User authentication failed!');
        history.push('/login');
      }
    } else {
      console.log('postDeleteArtistSetResultData = null');
    }
  });
};

export const obtainFormOutput = (formOutput, action = '', history, filterText = '', dispatch) => {
  dispatch({ type: 'manageFormOutput', formOutput });
  console.log('formOutput', formOutput);

  if (action === 'create') {
    postAddArtistSet({ ...formOutput }).then((postAddArtistSetResultData) => {
      if (postAddArtistSetResultData) {
        if (postAddArtistSetResultData.isAuth) {
          if (postAddArtistSetResultData.isAdded) {
            console.log(`postAddArtistSet - Successfully added artist set with artistSetSlugName ${postAddArtistSetResultData.artistSetSlugName}!`);
            updateSearch(filterText || '', dispatch);
          } else {
            console.log('postAddArtistSet - Failed to add artist set! Missing fields or artistSetSlugName exists');
          }
        } else {
          console.log('postAddArtistSet - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postAddArtistSetResultData = null');
      }
    });
  } else if (action === 'modify') {
    postEditArtistSet({ ...formOutput }).then((postEditArtistSetResultData) => {
      if (postEditArtistSetResultData) {
        if (postEditArtistSetResultData.isAuth) {
          if (postEditArtistSetResultData.isEdited) {
            console.log(`postEditArtistSet - Successfully edited artist set with artistSetSlugName ${postEditArtistSetResultData.artistSetSlugName}!`);
            updateSearch(filterText || '', dispatch);
          } else {
            console.log('postEditArtistSet - Failed to edit artist set! Missing fields or artistSetSlugName does not exist');
          }
        } else {
          console.log('postEditArtistSet - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postEditArtistSetResultData = null');
      }
    });
  }
};
